/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Input } from '@angular/core';
import { HttpService, I18nService, PromptService, ToastService } from '@dm/core';

@Component({
    selector: 'app-restart-shutdown',
    template: '',
})
export class RestartShutdownComponent implements OnInit {
    @Input() action = '';

    constructor(
        private prompt: PromptService,
        private i18n: I18nService,
        private http: HttpService,
        private toast: ToastService,
    ) { }

    ngOnInit(): void {
        let title;
        let content;
        let rest;
        let actionDes;
        switch (this.action) {
            case 'Restart':
                title = this.i18n.get('common.device_restart_label');
                actionDes = this.i18n.get('rest.restart_msg');
                content = this.i18n.get('common.restart_task_confirmation_message');
                rest = this.http.makeUrl('system.reboot');
                break;
            case 'Shutdown':
                title = this.i18n.get('common.device_shutdown_label');
                actionDes = this.i18n.get('rest.close_msg');
                content = this.i18n.get('common.powerOff_task_confirmation_message');
                rest = this.http.makeUrl('system.poweroff');
                break;
            default:
                break;
        }

        this.prompt.danger({
            width: 600,
            showPassword: true,
            title,
            content,
            onOk: (event) => {
                this.prompt.close();

                this.http.put(rest, { IMPORTANTPSW: event.password }, { mask: true })
                    .subscribe(() => {
                        this.toast.success(this.i18n.get('common.rest_success_label', [actionDes]));
                    });
            },
            onCancel: () => {
                this.prompt.close();
            },
        });
    }
}
